<template>
  <sui-card class="state-card">
    <sui-card-content class="compact">
      <b>Provider</b>
    </sui-card-content>
    <sui-card-content>
      <Logo :entity="host" />
      <b v-if="host.ipAddress">{{host.ipAddress}}&nbsp;<CopyIcon :value="host.ipAddress" /></b>
      <b v-if="!host.ipAddress">No IP address</b>
    </sui-card-content>
  </sui-card>
</template>

<script>
  export default {
    name: 'HostProviderCard',
    props: {
      host: {
        type: Object,
        required: true,
      },
    },
    computed: {
      provider() {
        return this.host._provider
      },
      title() {
        return this.host._provider.constructor.providerTitle
      },
    },
  }
</script>

<style scoped>
  .logo { height: 3.6rem; }
  .copy-button { margin-left: .2em; }
</style>
